import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, map, mergeMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  httpClient:HttpClient = inject(HttpClient);

  currentTree = new BehaviorSubject(null)
  currentTree$ = this.currentTree.asObservable()

  getTracking(payload:any,user_id?:any):Observable<any>{
    user_id = user_id ?? -1;
    return this.httpClient
    .post<any>(`api/learning/v1/get/progressions/${user_id}`,payload)
    .pipe(
      map((response) => response.data),
    );
  }

  getFullTimeCatalogues(payload:any ,user_id?:any):Observable<any>{
    user_id = user_id ?? -1;
    const params = new HttpParams({fromObject: payload});
    return this.httpClient
    .get<any>(`api/learning/v1/get/fullTime/${user_id}`,{params:params})
    .pipe(
      map((response) => response.data),
    );
  }

  getStatsRessources(payload: any,user_id?:any): Observable<any> {
    user_id = user_id ?? -1;
    return this.httpClient.post(`api/learning/v1/get/ressources/status/${user_id}`, payload);
  }

  getStatsCatalogues(payload: any,user_id?:any): Observable<any> {
    user_id = user_id ?? -1;
    return this.httpClient.post(`api/learning/v1/get/modules/completed/${user_id}`, payload);
  }

  getStatsEvaluations(user_id = ''): Observable<any> {
    return this.httpClient.get(`api/evaluation/spec/v1/get/stats/user/${user_id}`)
  }
}
